import { render } from "./UserEditModal.vue?vue&type=template&id=31238802&scoped=true&ts=true"
import script from "./UserEditModal.vue?vue&type=script&lang=ts"
export * from "./UserEditModal.vue?vue&type=script&lang=ts"

import "./UserEditModal.vue?vue&type=style&index=0&id=31238802&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31238802"]])

export default __exports__